const fieldStatus = {
  required: "required", //must be shown to the user and required not to be empty
  highlighted: "highlighted", //must be shown to the user, can be empty or default value
  relevant: "relevant", //needed to be available to be edited in advance mode.
  nonrelevant: "nonrelevant" //not relevant to product, need to be empty or default value
};

export default fieldStatus;
